/* eslint-disable no-unused-vars */
/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useLocalStorage } from 'src/hooks/useLocalStorage';
import { IPage } from 'src/interfaces';
import { CommonDropdown, RegularButton, CommonInput, FullScreenLoading } from 'pg-ui-library';
import attachmentBlue from 'src/assets/attachment-blue.svg';

import {
  MainContainer,
  TopBar,
  SearchLink,
  ViewHistory,
  InvoiceTitle,
  SubText,
  InfoGrid,
  InfoRow,
  Label,
  Value,
  Status,
  StatusDot,
  Divider,
  AmountGrid,
  NotesBox,
  Attachment,
  AttachmentIcon,
} from './viewstyles';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import InvoiceService from 'src/services/invoice.service';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { InvoiceSubmmisionModal } from './modals/approveReject';
import { InvoiceRejectionModal } from './modals/rejectModal';
import { da } from 'date-fns/locale';
import { formatCurrency } from 'src/utils/currencyFormat';
import { formatDecimal } from 'src/utils/units';
import { InvoiceDeleteModal } from './modals/deleteInvoice';

export const formatPeriodDate = (dateStr: string): string => {
  const date = new Date(dateStr);

  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
};

const formatToMMDDYYYY = (dateString?: string | null): string => {
  if (!dateString) return '';

  const [year, month, day] = dateString.split('-');
  return `${month}/${day}/${year}`;
};

const ViewInvoice: React.FC<IPage> = props => {
  const [isOpenDelete, setIsOpenDelete] = useState<boolean>(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { invoiceId } = useParams<{ invoiceId: string }>();

  const { isFetching, data, refetch } = useQuery(['invoice-details'], async () => {
    const result = await InvoiceService.getInvoiceDetails({ invoiceId: invoiceId });
    return result.data;
  });
  const getInvoiceDetails = data;

  const DeleteInvoice = (invoiceId: any) => {
    setIsOpenDelete(true);
  };

  const [showFun, setShowFun] = useState(true);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isOpenReject, setIsOpenReject] = useState<boolean>(false);
  const [userRole] = useLocalStorage('userRole', null);
  useEffect(() => {
    if (userRole === 'external_manager') {
      setShowFun(false);
    } else {
      setShowFun(true);
    }
  }, [userRole]);

  const statusMapping = (status?: string | null): string => {
    if (!status) return '';

    const mapping: Record<string, string> = {
      pay_processed: 'Pay Processed',
      bill_processed: 'Bill Processed',
      rejected: 'Rejected',
      draft: 'Draft',
      submitted: 'Submitted',
      approved: 'Approved',
      completed: 'Completed',
    };

    return mapping[status.toLowerCase()] ?? status;
  };

  const ApproveInvoice = (invoiceId: any) => {
    setIsOpen(true);
  };
  const RejectInvoice = (invoiceId: any) => {
    setIsOpenReject(true);
  };

  const EditInvoice = (invoiceId: any = '') => {
    navigate(`/invoices/${invoiceId}/edit`);
  };

  const status = data?.status?.toLowerCase() || '';

  // const isLockedStatus =
  //   data?.status?.toLocaleLowerCase() === 'approved' ||
  //   data?.status?.toLocaleLowerCase() === 'pay_processed' ||
  //   data?.status?.toLocaleLowerCase() === 'bill_processed';
  const isLockedStatus = ['pay_processed', 'bill_processed', 'completed', 'approved'].includes(status);

  console.log('Invoice Details:', typeof data?.approvedDate, data?.approvedDate);

  return (
    <MainContainer>
      {isFetching && <FullScreenLoading />}
      <InvoiceSubmmisionModal isOpen={isOpen} setIsOpen={setIsOpen} invoiceDetail={getInvoiceDetails} />
      <InvoiceRejectionModal isOpen={isOpenReject} setIsOpen={setIsOpenReject} invoiceDetail={getInvoiceDetails} />
      <InvoiceDeleteModal isOpen={isOpenDelete} setIsOpen={setIsOpenDelete} invoiceDetail={getInvoiceDetails} />
      <TopBar>
        <SearchLink>
          <Link to={`/invoices`}>Search Invoices</Link>
        </SearchLink>
      </TopBar>

      <InvoiceTitle>Invoice for {data?.invoiceDate}</InvoiceTitle>
      <SubText>{data?.employeeName}</SubText>

      <InfoGrid>
        <InfoRow>
          <Label>Status</Label>
          <Value>
            <Status>{statusMapping(data?.status)}</Status>
          </Value>
        </InfoRow>

        <InfoRow>
          <Label>Client</Label>
          <Value>{data?.clientName}</Value>
        </InfoRow>

        <InfoRow>
          <Label>Invoice ID</Label>
          <Value>
            {data?.invoiceShowId} {`(Version ${data?.version})`}{' '}
          </Value>
        </InfoRow>

        <InfoRow>
          <Label>Assignment</Label>
          <Value>{data?.assignmentName}</Value>
        </InfoRow>

        <InfoRow>
          <Label>Invoice Number</Label>
          <Value>{data?.invoiceNumber}</Value>
        </InfoRow>

        <InfoRow>
          <Label>Invoice Period</Label>
          {data?.periodStart && data?.periodEnd && (
            <Value>
              {formatPeriodDate(data.periodStart)} - {formatPeriodDate(data.periodEnd)}
            </Value>
          )}
        </InfoRow>

        <InfoRow>
          <Label>Approver</Label>
          <Value>{data?.managerName}</Value>
        </InfoRow>

        <InfoRow>
          <Label>Backup Approver</Label>
          <Value>{data?.coApproverName}</Value>
        </InfoRow>
        <InfoRow>
          {data?.rejectedDate ? (
            <>
              <Label>Rejected At</Label>
              <Value style={{ color: 'red' }}>
                {formatPeriodDate(data?.rejectedDate)} by {data?.rejectedby}{' '}
              </Value>
            </>
          ) : (
            <>
              <Label>Approved At</Label>
              <Value>
                {formatToMMDDYYYY(data?.approvedDate)} by {data?.approvedby}{' '}
              </Value>
            </>
          )}
        </InfoRow>
      </InfoGrid>
      <Divider />

      <AmountGrid>
        {showFun ? null : (
          <InfoRow>
            <Label>Billable Amount</Label>
            <Value>{formatCurrency(data?.billableAmount, 'USD')}</Value>
          </InfoRow>
        )}

        <InfoRow>
          <Label>Submitted Amount</Label>
          <Value>{formatCurrency(data?.submittedAmount, 'USD')}</Value>
        </InfoRow>

        <InfoRow>
          <Label>Total Units</Label>
          <Value>{formatDecimal(data?.totalUnits)}</Value>
        </InfoRow>
      </AmountGrid>

      <Divider />

      <Label>Notes</Label>
      <NotesBox value={data?.notes} />

      <Label style={{ marginTop: '24px' }}>Attachments</Label>
      <div>
        <p style={{ fontSize: '1.4rem' }}>
          {data?.attachments && data.attachments.length > 0 && (
            <img src={attachmentBlue} alt="Formatting Icon" style={{ height: '17px', margin: '0px 10px 0px 2px' }} />
          )}
          {data?.attachments &&
            data?.attachments.length > 0 &&
            data?.attachments.map((attachment, index) => (
              <React.Fragment key={index}>
                <a href={attachment.attachmentUrl} target="_blank" rel="noopener noreferrer">
                  {attachment.attachmentName}
                </a>
                {index < (data?.attachments || []).length - 1 && ', '}
              </React.Fragment>
            ))}
        </p>
      </div>

      <Divider />
      {/* {showFun ? (
        <>
          {!isLockedStatus ? <RegularButton onClick={() => EditInvoice(invoiceId)}>Edit Invoice</RegularButton> : null}

          {!isLockedStatus ? (
            <RegularButton onClick={() => DeleteInvoice(invoiceId)}>Delete Invoice</RegularButton>
          ) : null}
        </>
      ) : (
        <>
          {data?.status?.toLowerCase() !== 'rejected' && (
            <RegularButton onClick={() => RejectInvoice(invoiceId)}>Reject Invoice</RegularButton>
          )}

          {data?.status?.toLowerCase() !== 'approved' && (
            <RegularButton onClick={() => ApproveInvoice(invoiceId)}>Approve Invoice</RegularButton>
          )}
        </>
      )} */}
      {showFun ? (
        <>
          {!isLockedStatus && (
            <>
              <RegularButton onClick={() => EditInvoice(invoiceId)}>Edit Invoice</RegularButton>

              <RegularButton onClick={() => DeleteInvoice(invoiceId)}>Delete Invoice</RegularButton>
            </>
          )}
        </>
      ) : (
        <>
          {!isLockedStatus && (
            <>
              {status !== 'rejected' && (
                <RegularButton onClick={() => RejectInvoice(invoiceId)}>Reject Invoice</RegularButton>
              )}

              {status !== 'approved' && (
                <RegularButton onClick={() => ApproveInvoice(invoiceId)}>Approve Invoice</RegularButton>
              )}
            </>
          )}
        </>
      )}
    </MainContainer>
  );
};

export default ViewInvoice;
